import { FunctionDeclaration, SchemaType } from "@google/generative-ai";

/**
 * This file contains details about the tools available in the multimodal live API.
 */

/**
 * Tool to display LaTeX formulas and formatted details.
 */
const formulaTool: FunctionDeclaration = {
    name: "get_formula",
    description: "Displays LaTeX formulas and formatted details. Use this tool only when explicitly required by the user, such as when the user requests detailed or accurate data from the vector base or database. Avoid unnecessary calls; trigger only for explicit queries like 'complete details about...', 'give me the formula for...', 'show formulas related to...', or 'search the database for...'. Use efficiently and avoid assumptions.",
    parameters: {
        type: SchemaType.OBJECT,
        properties: {
            formulaList: {
                type: SchemaType.STRING,
                description: "Comma-separated list of formulas the user wants.",
            },
            prompt: {
                type: SchemaType.STRING,
                description: "text prompt that user have requested. give exact request user have given in text"
            }
        },
        required: ["formulaList", "prompt"],
    },
};

/**
 * Tool to calculate the formula
 */

const calculateFormula: FunctionDeclaration = {
    name: "calculate_formula",
    description: "Calculates the formula based on the input provided by the user. Use this tool when the user requests a calculation based on a formula. For example, 'calculate the value of...', 'what is the result of...', 'find the value of...', or 'solve the formula for...' and related query which requests sample or defined calculation.",
    parameters: {
        type: SchemaType.OBJECT,
        properties: {
            prompt: {
                type: SchemaType.STRING,
                description: "text prompt that user have requested. give exact request user have given in text"
            },
            intent: {
                type: SchemaType.STRING,
                description: "based on chat memory identify what user want and what is end goal of it. analyze the user queries and response from ai and identify the intent of user"
            }
        },
        required: ["prompt", "intent"],
    },
}



/**
 * Tool to display an Altair graph in JSON format.
 */
const altair: FunctionDeclaration = {
    name: "render_altair",
    description: "Displays an Altair graph in JSON format.",
    parameters: {
        type: SchemaType.OBJECT,
        properties: {
            prompt: {
                type: SchemaType.STRING,
                description: "text prompt that user have requested. give exact request user have given in text"
            },
            json_graph: {
                type: SchemaType.STRING,
                description: "JSON string representation of the graph to render.",
            },
            quickExplaination: {
                type: SchemaType.STRING,
                description: "give a quick explaination about the graph. what is the graph about and what is the data in the graph or other related details."
            }
        },
        required: ["json_graph","quickExplaination"],
    },
};

/**
 * Tool to generate a Mermaid.js visualization from provided data.
 */
const mermaidVisualizationTool: FunctionDeclaration = {
    name: "get_mermaid_visualization",
    description: "Generates a Mermaid.js visualization from provided data.",
    parameters: {
        type: SchemaType.OBJECT,
        properties: {
            prompt: {
                type: SchemaType.STRING,
                description: "text prompt that user have requested. give exact request user have given in text"
            },
            mermaidCode: {
                type: SchemaType.STRING,
                description: `The Mermaid.js code version 11.4.1 is to be used for generating visualizations. Ensure all generated Mermaid code is modern, accurate, and error-free.

Always wrap the content of nodes in double quotes (e.g., ["Node Content"]) to avoid parsing errors.
Avoid using unquoted node content like [Node Content] as it will result in invalid Mermaid syntax.
Adhere strictly to Mermaid.js syntax rules for all types of diagrams, including flowcharts, sequence diagrams, and others.
Provide clean, readable code with proper indentation and consistent style.
Example:
mermaid
Copy
Edit
graph LR  
A["Start Node"] --> B["Next Node"]  
B --> C["Final Node"]  
Follow these guidelines to ensure the generated visualizations work without errors.`,
            },
        },
        required: ["mermaidCode"],
    },
};


const showDetails: FunctionDeclaration = {
    name: "get_formula_showcase",
    description: "Use this tool to display details or formulas from chat memory when the user requests specific information. For example, 'Show me details about...'. Ensure that there is sufficient data in the memory to fulfill the request and that retrieving and displaying this information will adequately address the user's query. use this when user ask for formted details like code block ,tables and other markdown formated text",
    parameters: {
        type: SchemaType.OBJECT,
        properties: {
            prompt: {
                type: SchemaType.STRING,
                description: "text prompt that user have requested. give exact request user have given in text"
            },
            intent:{
                type: SchemaType.STRING,
                description: "based on chat memory identify what user want and what is end goal of it. analyze the user queries and response from ai and identify the intent of user.analyze the user intent from chat memory and identify long term intent dont just give the summury of the prompt"
            }            

        },
        required: [],
    },
};

const tools = { formulaTool, altair, mermaidVisualizationTool, calculateFormula, showDetails };

export default tools;